import { useCallback, useMemo } from 'react';

import { useAppDispatch } from '~/modules/store';
import { UIStateActions } from '~/modules/uiState/uiState.redux';
import { ACTIONS } from '~/services/toasts/internalServerError';

import { testsApi } from '../../tests.api';
import { showGroupError } from '../../tests.utils';

export const useUnlinkComponentFromTest = () => {
  const dispatch = useAppDispatch();
  const [unlinkComponent, unlinkComponentState] = testsApi.useUnlinkComponentMutation();

  const handleUnlinkComponent = useCallback(
    async ({ testId, componentId }: { testId: string; componentId: string }) => {
      const result = unlinkComponent({ testId, componentId }).unwrap();

      result
        .then(() => {
          dispatch(UIStateActions.forgetCollapsedGroup({ collapsedGroupId: componentId, testId }));
        })
        .catch((error) => {
          showGroupError(ACTIONS.UPDATE, error);
        });

      return result;
    },
    [unlinkComponent, dispatch],
  );

  return useMemo(
    () => [handleUnlinkComponent, unlinkComponentState] as const,
    [handleUnlinkComponent, unlinkComponentState],
  );
};
